import React, { useState } from "react"
import { Col, Row, Form, Dropdown } from "react-bootstrap"
import { Formik, Form as FormikForm, Field } from "formik"
import * as API from "../../../services/httpService"
import * as Yup from "yup"

import FeedbackFormStarRate from "./feedbackFormStarRate"
import FeedbackFormTextArea from "./feedbackFormTextArea"
import FeedbackFormNumberRate from "./feedbackFormNumberRate"
import FeedbackFormDropdownList from "./feedbackFormDropdownList"
import FeedbackFormTextBox from "./feedbackFormTextBox"

function FeedbackForm(props) {
  const {
    customerName,
    customeEmail,
    orderRef,
    productName,
    productSearchCode,
    campaign,
    salesChannel,
    feedbackWhereKnowAboutUsList,
  } = props

  const formRef = React.useRef()
  const [submitted, setSubmitted] = useState(false)

  const validationSchema = Yup.object().shape({
    experienceRate: Yup.number()
      .required("Required")
      .min(1, "Required"),
    feedback: Yup.string().required("Required"),
    recommendUsRate: Yup.number()
      .required("Required")
      .min(1, "Required"),
    whereKnowAboutUs: Yup.string().required("Required"),
    whereKnowAboutUsOthers: Yup.string().when("whereKnowAboutUs", {
      is: "Others", // alternatively: (val) => val == true
      then: Yup.string().required("Required"),
    }),
  })

  return (
    <Formik
      initialValues={{
        experienceRate: 0,
        feedback: "",
        recommendUsRate: 0,
        whereKnowAboutUs: "",
        whereKnowAboutUsOthers: "",
      }}
      enableReinitialize={true}
      validationSchema={validationSchema}
      validateOnMount={true}
      innerRef={formRef}
      onSubmit={(values, actions) => {
        setSubmitted(true)

        let finalWhereKnowAboutUs = values.whereKnowAboutUs

        if (values.whereKnowAboutUs == "Others") {
          finalWhereKnowAboutUs = values.whereKnowAboutUsOthers
        }

        API.apiPostRequest(
          "/Claim/SubmitFeefoFeedback",
          {
            CustomerName: customerName,
            CustomeEmail: customeEmail,
            OrderRef: orderRef,
            ProductName: productName,
            ProductSearchCode: productSearchCode,
            ServiceComment: values.feedback,
            ExperienceRate: values.experienceRate,
            RecommendUsRate: values.recommendUsRate,
            Campaign: campaign,
            SalesChannel: salesChannel,
            WhereKnowAboutUs: finalWhereKnowAboutUs,
          },
          null
        ).then(
          apiResponse => {
            let apiResponseData = apiResponse.data
          },
          error => {
            //console.log(error)
          }
        )
      }}
    >
      {({ values }) => (
        <>
          {!submitted && (
            <>
              <FormikForm>
                <p className="mt-4">
                  <span className="receiveClaimLabel fontWeightBold">
                    Before you go, we would love to hear from you!
                  </span>
                </p>
                <Field
                  textDesc="How easy was your claims submission experience?"
                  name="experienceRate"
                  component={FeedbackFormStarRate}
                  rateItem={[1, 2, 3, 4, 5]}
                />
                <Field
                  textDesc="Thank you for your rating!
                    Tell us more about your experience!"
                  name="feedback"
                  component={FeedbackFormTextArea}
                />
                <Field
                  textDesc="How likely would you recommend us to your friends and family?"
                  name="recommendUsRate"
                  component={FeedbackFormNumberRate}
                  rateItem={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10]}
                />
                <Field
                  textDesc="Lastly, how did you get to know about us?"
                  name="whereKnowAboutUs"
                  component={FeedbackFormDropdownList}
                  dropdownItem={feedbackWhereKnowAboutUsList}
                />
                {values.whereKnowAboutUs === "Others" && (
                  <>
                    <Field
                      name="whereKnowAboutUsOthers"
                      component={FeedbackFormTextBox}
                    />
                  </>
                )}

                <Row>
                  <Col
                    xs={"auto"}
                    md={"auto"}
                    className="textforinput marginTop10px marginBottom19px marginLeftRightAuto"
                  >
                    <button
                      type="submit"
                      className="RectangleBtn text-center NextBtn"
                      // onClick={() => nextPage()}
                    >
                      Done!
                    </button>
                  </Col>
                </Row>
              </FormikForm>
            </>
          )}

          {submitted && (
            <>
              <span className="receiveClaimLabel MarginTop15 MarginBottom15">
                Feedback Received! Thank you for helping us improve!
              </span>
            </>
          )}
        </>
      )}
    </Formik>
  )
}

export default FeedbackForm
